module.exports = __webpack_public_path__ + "static/media/xmg_2.8c2ab2c8.png";